import { jsxs as _jsxs } from "react/jsx-runtime";
import { useCurrentBreakpoint } from "../../../../../../../hooks/useCurrentBreakpoint";
import styles from "./StoreLocatorProductAttributeValues.module.scss";
export const StoreLocatorProductAttributeValues = ({ values, isListView, }) => {
    const { specificBreakpoint } = useCurrentBreakpoint();
    const isTablet = ["xSmall", "smallMedium"].includes(specificBreakpoint);
    const maxProductVarietyLength = isTablet ? 64 : 36;
    const formattedValues = values.map(({ value }) => value.toString());
    const displayedValues = [];
    let letterCount = 0;
    for (const rawValue of formattedValues) {
        const value = rawValue.toString();
        const alphaLength = value.replace(/[^a-zA-Z]/g, "").length;
        const separatorLength = 3;
        const newLetterCount = letterCount + alphaLength + separatorLength;
        if (isListView && newLetterCount - separatorLength > maxProductVarietyLength)
            break;
        displayedValues.push(value);
        letterCount = newLetterCount;
    }
    const restValuesCount = formattedValues.length - displayedValues.length;
    const result = displayedValues.join(" · ");
    return (_jsxs("div", { className: styles.productAttributeValues, "data-testid": "storeLocatorAttributeValues", children: [result, restValuesCount > 0 && (_jsxs("div", { className: styles.productAttributeValuesCount, "data-testid": "attributeValuesCount", children: [" ", "+ ", restValuesCount] }))] }));
};
//# sourceMappingURL=StoreLocatorProductAttributeValues.js.map